<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-6 contact_page contact_page-light">
        <h2 class="contact_page-title">ჩვენ შესახებ</h2>
        <div class="contact_page-border_line mt-5vh mb-5vh"></div>
        <p class="contact_page-text">
          კომპანია Skin Love-მა მსოფლიოს სანდო ბრენდების მაღალხარისხიანი პროდუქცია ერთ სივრცეში მოაქცია.
          უმაღლესი ხარისხის ორიგინალ კოსმეტიკას, სახისა და ტანის მოვლის საშუალებებს skinlove.ge სახლიდან გაუსვლელად, ხელსაყრელ ფასად გთავაზობთ.
        </p>
        <p class="contact_page-text mt-3">
          გამომდინარე იქიდან, რომ არსებობს ბიუთი ბოქსები და ამ ბიუთი ბოქსების გამომწერებისთვის, დამატებით, არსებობს განსაკუთრებული შეთავაზებები,
          ჩვენი გუნდი მუდამ ცდილობს, გამოწეროს სილამაზის ბოქსები მთელი მსოფლიოდან და აქტიურად ჩაერთოს ამა თუ იმ შეთავაზებაში, რაც შესაძლებლობას გვაძლევს, რომ
          ჩვენი მომხმარებლებისთვის ხელმისაწვდომი გავხადოთ სხვადასხვა წამყვანი ბრენდის ორიგინალი და ძვირადღირებული პროდუქცია, იმაზე ბევრად ნაკლებ ფასად,
          ვიდრე მისი საბაზრო ღირებულებაა (ხშირად ასეთი პროდუქციის ფასი ჩვენთან 50%-80%-ით ნაკლებია, მის რეალურ ღირებულებასთან შედარებით).
        </p>
      </div>
      <div class="col-12 col-md-6 contact_page contact_page-dark">
        <h2 class="contact_page-title">კონტაქტი</h2>
        <div class="contact_page-border_line mt-5vh mb-5vh"></div>
        <div class="d-flex">
          <div class="contact_page-text bold">ელ. ფოსტა:</div>
          <a
            class="contact_page-text contact_page-text-link"
            href="Mailto:skinlove.ge@gmail.com"
          >skinlove.ge@gmail.com</a>
        </div>
        <div class="d-flex">
          <div class="contact_page-text bold">ტელ:</div>
          <a
            class="contact_page-text contact_page-text-link"
            href="Tel:+995598997797"
          >+995 598 99 77 97</a>
        </div>
        <div class="d-flex">
          <div class="contact_page-text bold">სოციალური მედია:</div>
          <a
            href="https://www.facebook.com/Skinlove.ge"
            target="_blank"
            rel="noopener noreferrer"
            class="contact_page-text contact_page-text-link mr-3"
          >
            <span class="fa fa-facebook-square"></span> facebook
          </a>
          <a
            href="https://www.instagram.com/skinlove.ge"
            target="_blank"
            rel="noopener noreferrer"
            class="contact_page-text contact_page-text-link"
          >
            <span class="fa fa-instagram"></span> instagram
          </a>
        </div>
        <div class="d-flex">
          <div class="contact_page-text bold">მისამართი:</div>
          <a
            href="https://www.google.com/maps/place/12+%E1%83%9B%E1%83%A8%E1%83%95%E1%83%98%E1%83%93%E1%83%9D%E1%83%91%E1%83%98%E1%83%A1+%E1%83%92%E1%83%90%E1%83%9B%E1%83%96%E1%83%98%E1%83%A0%E1%83%98,+Gori/@41.9851106,44.098976,17z/data=!3m1!4b1!4m5!3m4!1s0x40449ea2eda2d23d:0xce6ad0997159f237!8m2!3d41.9851106!4d44.1011647"
            target="_blank"
            rel="noopener noreferrer"
            class="contact_page-text contact_page-text-link"
          >მშვიდობის გამზირი 12, გორი</a>
        </div>
        <div class="google_map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2965.607228655504!2d44.09522711473847!3d41.98724197921369!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40449ebd101f61ed%3A0x4ece76aac7e92173!2zMTIg4YOb4YOo4YOV4YOY4YOT4YOd4YOR4YOY4YOhIOGDkuGDkOGDm-GDluGDmOGDoOGDmCwg4YOS4YOd4YOg4YOY!5e0!3m2!1ska!2sge!4v1594226524358!5m2!1ska!2sge"
            width="100%"
            height="100%"
            frameborder="0"
            style="border:0;"
            allowfullscreen
            aria-hidden="false"
            tabindex="0"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "contact"
};
</script>

<style lang="scss" scoped>
@import "~@/styles/global";

.contact_page {
  width: 100%;
  min-height: 100vh;
  padding: 5vh;
  &-light {
    background: white;
    color: black;
  }
  &-dark {
    background: black;
    color: white;
  }
  &-title {
    font-family: $fontALKSanet;
    font-size: $font-lg;
    margin-bottom: auto;
    letter-spacing: 2px;
    font-weight: bold;
  }
  &-border_line {
    width: 20%;
    height: 2px;
    background: $greyLight;
  }
  &-text {
    font-family: $fontALKSanet;
    font-size: $font-sm;
    text-decoration: none;
    &.bold {
      font-weight: bold;
      margin-right: 3vh;
    }
    &-link {
      color: $white;
    }
  }
}
.google_map-container {
    margin-top: 2vh;
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
    height: 60vh;
}
@media screen and (min-width: 768px) {
    .contact_page-text{
        font-size: $font-md;
    }
}
</style>